import React, { useEffect, useState } from 'react';
import Amplify, { Auth, Logger } from 'aws-amplify';
import { SecuredVendorApp } from '@wfm-component-lib/auth';
import '@wfm-component-lib/auth/dist/index.css'

import ExternalApps from './components/ExternalApps/ExternalApps';
import appConfig from './AppConfig';
import './App.scss';
import './index.css';

Amplify.Logger.LOG_LEVEL = appConfig.LOG_LEVEL || 'ERROR';
const logger = new Logger('App.js');

Amplify.configure(appConfig);
logger.debug('Amplify.configure', appConfig);

const APPS_DATA = appConfig.vmaApps;

function App() {
  
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  
  useEffect(() => {
    // Check if user is authenticated
    const checkAuth = async () => {
      try {
        const userData = await Auth.currentAuthenticatedUser();
        logger.debug('User authenticated:', userData);
        
        // Check if this is a return from MFA completion
        const mfaCompleted = sessionStorage.getItem('mfaCompleted');
        
        // Check if user is an external vendor who needs MFA
        const userGroups = userData.signInUserSession?.idToken?.payload['cognito:groups'] || [];
        const isExternalVendor = userGroups.includes('external-vendor');
        
        if (isExternalVendor && !mfaCompleted) {
          logger.debug('External vendor detected without MFA completion, redirecting to MFA');
          // Store the email for MFA
          const email = userData.signInUserSession?.idToken?.payload?.email;
          if (email) {
            sessionStorage.setItem('userEmail', email);
          }
          // Redirect to the MFA page
          window.location.href = '/mfa';
          return;
        }
        logger.debug('User is fully authenticated');
        setIsCheckingAuth(false);
      } catch (error) {
        logger.error('Authentication error:', error);
        // If not authenticated, redirect to login page
        window.location.href = '/login';
      }
    };
    
    checkAuth();
  }, []);

  // Show loading state while checking authentication
  if (isCheckingAuth) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  // Only render the app when authentication check is complete
  return (
    <SecuredVendorApp
      appName={appConfig.appName}
      requiredCognitoGroups={appConfig.requiredCognitoGroups}
      groupToSkipVerification={appConfig.groupToSkipVerification}
    >
      <ExternalApps apps={APPS_DATA} />
    </SecuredVendorApp>
  );
}

export default App;
